(function () {
  const productSchema = document.getElementById('ProductSchema');
  if (!productSchema) { return; }

  const locationsDataEl = document.querySelector(`[data-store-locations]`);
  if (!locationsDataEl) { return; }

  const schema = JSON.parse(productSchema.innerHTML);
  const locations = JSON.parse(locationsDataEl.innerHTML);
  const firstOffer = schema.offers[0];

  schema.offers = meta.product.variants.map((variant) => {
    const offer = {
      ...firstOffer,
      price: variant.price / 100,
    }

    if (variant.public_title !== 'Shipping') {
      const gopuff_location_id = variant.sku.split('_')[1];
      const location = locations.find((store) => {
        return String(store.gopuff_location_id) === String(gopuff_location_id);
      });

      offer.availableAtOrFrom = {
        "@type": "Place",
        "name": location?.name,
        "branchCode": location?.bevmo_id,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": location?.address_1,
          "addressLocality": location?.city,
          "addressRegion": location?.state,
          "postalCode": location?.zip,
          "addressCountry": 'US',
        },
      };
      offer.potentialAction = {
        "@type": "http://schema.org/BuyAction",
      };
      offer.deliveryLeadTime = {
        "@type": "http://schema.org/QuantitativeValue",
        "value": 0
      };
      offer.availableDeliveryMethod = "http://schema.org/OnSitePickup";
    }

    return offer;
  });

  var el = document.createElement('script');
  el.type = 'application/ld+json';
  el.text = JSON.stringify(schema);
  document.querySelector('head').appendChild(el);

  productSchema.innerHTML = JSON.stringify(schema);
})();